<div class="modal-container">
  <div class="modal-top">
    <h2 mat-dialog-title>Anslut din mottagning till Vården.se</h2>

    <div class="close-btn">
      <app-ui-icon (click)="closeDialog()" color="var(--blue-3)" name="close" size="md"></app-ui-icon>
    </div>
  </div>

  <div id="bliKundForm"></div>
</div>
